import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const inputCls = "w-full rounded-lg border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:border-[#0077B6]";

export function Login() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      navigate(u.role === "admin" ? "/admin" : (loc.state?.from || "/hesabim"));
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="container-max px-4 md:px-8 section-pad max-w-md">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mb-2">Giriş Yap</h1>
      <p className="text-slate-600 text-sm mb-6">Sipariş geçmişiniz ve favorileriniz için.</p>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="login-email" required type="email" placeholder="E-posta" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="login-password" required type="password" placeholder="Şifre" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">{loading ? "..." : "Giriş Yap"}</button>
      </form>
      <p className="text-sm text-slate-600 mt-4">Hesabınız yok mu? <Link to="/kayit" className="text-[#0077B6] font-semibold">Kayıt olun</Link></p>
    </div>
  );
}

export function Register() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Hesabınız oluşturuldu");
      navigate("/hesabim");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="container-max px-4 md:px-8 section-pad max-w-md">
      <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mb-2">Hesap Oluştur</h1>
      <p className="text-slate-600 text-sm mb-6">Hızlı alışveriş ve özel teklifler.</p>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="reg-name" required placeholder="Ad Soyad" className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="reg-email" required type="email" placeholder="E-posta" className={inputCls} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <input data-testid="reg-phone" placeholder="Telefon" className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <input data-testid="reg-password" required type="password" placeholder="Şifre (en az 6 karakter)" className={inputCls} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">{loading ? "..." : "Kayıt Ol"}</button>
      </form>
      <p className="text-sm text-slate-600 mt-4">Zaten üye misiniz? <Link to="/giris" className="text-[#0077B6] font-semibold">Giriş yapın</Link></p>
    </div>
  );
}
